<!-- 1. Loading State -->
@if (loading) {
  @for (r of rowsArray; track $index) {
    <tr>
      @for (c of colsArray; track $index) {
        <td>
          <div class="skeleton skeleton-text"></div>
        </td>
      }
    </tr>
  }
}

<!-- 2. Error State -->
@if (!loading && error) {
  <tr>
    <td [attr.colspan]="columns">
      <div class="error-wrapper error">
        <i class="fas fa-exclamation-circle"></i>
        <span>{{ error }}</span>
      </div>
    </td>
  </tr>
}

<!-- 3. Empty State -->
@if (!loading && !error && empty) {
  <tr>
    <td [attr.colspan]="columns">
      <div class="error-wrapper info">
        <i class="fas fa-info-circle"></i>
        <span>No data found.</span>
      </div>
    </td>
  </tr>
}

<!-- 4. SUCCESS State -->
@if (!loading && !error && !empty) {
  <ng-content></ng-content>
}
